import React, {Component} from 'react';
import PropTypes from "prop-types";
import ScrollAnimation from 'react-animate-on-scroll';

class Services extends Component {
  render() {
    //Service loop END
    return (
      <React.Fragment>
        <section id="services" className="services ptb-100">
          <div className="container">
            <ScrollAnimation animateIn="fadeInUp">
              <div className="row">
                <div className="col-md-12 text-center">
                  <div className="section-title">
                    <h2>{this.props.sectionTitle}</h2>
                    <p style={{marginTop: "20px", display: "inline-block"}}>
                      <strong>{this.props.sectionDescriptionName}</strong>
                      {this.props.sectionDescription}
                    </p>
                    <h3 className="section-title-bg">
                      {this.props.SectionbgTitle}
                    </h3>
                  </div>
                </div>
                <div className="col-lg-8 col-md-12 text-left list-style">
                  <ul>
                    <li>{this.props.SectionbgList1}</li>
                    <li>{this.props.SectionbgList2}</li>
                    <li>{this.props.SectionbgList3}</li>
                    <li>{this.props.SectionbgList4}</li>
                    <li>{this.props.SectionbgList5}</li>
                    <li>{this.props.SectionbgList6}</li>
                    <li>{this.props.SectionbgList7}</li>
                    <li>{this.props.SectionbgList8}</li>
                    <li>{this.props.SectionbgList9}</li>
                  </ul>
                </div>
                <div
                  className="col-lg-4 col-md-12 font-size-medium text-italic text-right vertical-align">
                  <span>"Marele avantaj în a îmbătrâni este că nu pierzi toate celelalte vârste prin care ai trecut."</span>
                  <br/>
                  <span className="text-right text-bold">Madeleine L'Engle</span>
                </div>
              </div>
            </ScrollAnimation>
          </div>
        </section>
      </React.Fragment>
    );
  }
}

//Props Types
Services.propTypes = {
  SectionbgTitle: PropTypes.string,
  sectionTitle: PropTypes.string,
  sectionDescription: PropTypes.string,
  servicesData: PropTypes.array
};

//Default Props
Services.defaultProps = {
  SectionbgTitle: "Servicii",
  sectionTitle: "Servicii",
  sectionDescriptionName: "Casa Maria ",
  sectionDescription: "Va ofera:",
  SectionbgList1: "Un mediu plăcut și cald",
  SectionbgList2: "Personal calificat",
  SectionbgList3: "Asistenta sociala",
  SectionbgList4: "Asistenta psihologică",
  SectionbgList5: "Asistenta medicală",
  SectionbgList6: "Cazare",
  SectionbgList7: "Mâncare stil catering adaptat nevoilor și afecțiunilor beneficiarului",
  SectionbgList8: "Camere de 2-3 persoane",
  SectionbgList9: "Beneficiile sunt observate, gradul de confort si calitatea vieții pe care o au în cadrul centrului."
};

export default Services;
